import { IPaymentData } from '../../core/interfaces/payment-data';

export class AddPaymentData {
  static readonly type = '[Payment] AddPaymentData';

  constructor(public paymentData: IPaymentData) {}
}
